import script from "./ListColumnsName.vue?vue&type=script&setup=true&lang=js"
export * from "./ListColumnsName.vue?vue&type=script&setup=true&lang=js"

import "./ListColumnsName.vue?vue&type=style&index=0&id=2fd8aa6e&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\68\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fd8aa6e"]])

export default __exports__